import {twMerge} from '../../../common/twMerge';
import {ErrorAreaChildProps} from './ErrorAreaChildProps.interface';

export function ErrorAreaTitle({
  isMobile,
  children,
  className,
  ...props
}: {isMobile?: boolean} & ErrorAreaChildProps) {
  return (
    <div
      className={twMerge(
        'font-large3-bold block whitespace-pre-wrap break-all text-center text-theme-solid-100',
        isMobile && 'font-medium2-bold',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export const ErrorAreaTitleType = (<ErrorAreaTitle />).type;
